<template>
    <div>
        <div class="modal-boddy">
            <div class="modal-text">
                <div class="text-justify">
                    <span>
                        A empresa {{fornecedorAceite.razaoSocialFornecedor}}, inscrita no CNPJ
                        {{fornecedorAceite.cnpjFornecedor | az-cpf-cnpj}}, com sede na cidade de
                        {{fornecedorAceite.municipioFornecedor}} - {{fornecedorAceite.ufFornecedor}},
                        {{fornecedorAceite.logradouroFornecedor}} - {{fornecedorAceite.numLogradouroFornecedor}},
                        telefone {{fornecedorAceite.telefoneFornecedor | az-phone}}, através do presente instrumento
                        torna público o credenciamento do(a) senhor(a) {{fornecedorAceite.nomeUsuario}},
                        CPF {{fornecedorAceite.cpfUsuario | az-cpf-cnpj}}, com endereço para correspondência
                        eletrônica através do e-mail {{fornecedorAceite.emailUsuario}}, para participar deste processo
                        de licitação na modalidade de "{{getModalidadeLicitacao(licitacao.modalidade)}}", podendo para tanto, desempenhar
                        todas as funções inerentes ao certame tais como concordar com todas as condições previstas
                        no instrumento convocatório, apresentação de propostas, oferta e desistência de lances,
                        apresentação de recursos e tudo mais que se fizerem necessários ao de suas atividades como se o
                        próprio licitante fosse.
                    </span>
                </div>
                <v-layout row wrap>
                    <v-flex xs12 sm4 md4></v-flex>
                    <v-flex xs12 sm8 md8>
                        <v-checkbox
                                :label="`Li e concordo com os termos acima.`"
                                v-model="aceitouTermos"
                                color="primary"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>
            </div>
        </div>

        <div class="modal-actions__steps">
            <v-btn color="primary btn-voltar" outline @click="$emit('voltar')">Voltar</v-btn>
            <span>Passo {{passoAtual}}/{{quantidadePassos}}</span>
            <v-btn color="primary btn-avancar" @click="$emit('proximo')" :disabled="!aceitouTermos">{{ passoAtual === quantidadePassos ? 'Finalizar' : 'Avançar'}}</v-btn>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import { modalidadesLicitacao } from '@/commons/constants'
    export default {
        name: 'LicitacaoFornecedorTermosCredenciamento',
        props:['passoAtual', 'quantidadePassos'],
        data() {
            return {
                aceitouTermos: false,
                modalidadesLicitacao
            }
        },
        computed: {
            ...mapState(['fornecedorAceite', 'licitacao'])
        },
        methods:{
          getModalidadeLicitacao(modalidade){
            return this.modalidadesLicitacao[modalidade]
          },
        }
    }
</script>
